import { Service } from '@genial/services';
import {
  V1DeleteBasketCustomerOfferByBasketCustomerOfferIdRequest,
  V1DeleteBasketOfferByBasketAdvisorOfferIdRequest,
  V1GetCoesOffersByDetailProductIdRequest,
} from '@genial/services/dist/apis';

import { screenName } from '../../../store/batchTicket/constants';
import {
  PostProductBasketServiceProps,
  PutCustomerOfferByBasketServiceProps,
  PutProductBasketServiceProps,
} from '../utils/types';

export const postProductBasketService = async ({
  quantity = 1,
  requestedPrice = 0,
  requestedQuantity = 1,
  ...rest
}: PostProductBasketServiceProps) => {
  const { data, statusCode } = await Service.Basket.V1.postOffer({
    screenName,
    createOfferOrderRequest: {
      ...rest,
      quantity,
      requestedPrice,
      requestedQuantity,
    },
  });

  if (statusCode === 201) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};

export const deleteProductBasketService = async (
  data: V1DeleteBasketOfferByBasketAdvisorOfferIdRequest
) => {
  const { statusCode } = await Service.Basket.V1.deleteOfferByBasketAdvisorOfferId({
    screenName,
    ...data,
  });

  return statusCode === 200;
};

export const putProductBasketService = async (
  basketAdvisorOfferId: string,
  { quantity = 1, requestedPrice = 0, requestedQuantity = 1, ...rest }: PutProductBasketServiceProps
) => {
  const { data, statusCode } = await Service.Basket.V1.putAdvisorOfferByBasketAdvisorOfferId({
    screenName,
    basketAdvisorOfferId,
    updateBasketAdvisorOfferRequest: {
      ...rest,
      quantity,
      requestedPrice,
      requestedQuantity,
    },
  });

  if (statusCode === 200) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};

export const cleanProductsBasketService = async (basketAdvisorOrderId: string) => {
  const { statusCode } = await Service.Basket.V1.deleteBasketAdvisorIdByCleanOffers({
    screenName,
    basketAdvisorOrderId,
  });

  return statusCode === 200;
};

export const deleteCustomerOfferByBasketService = async (
  data: V1DeleteBasketCustomerOfferByBasketCustomerOfferIdRequest
) => {
  const { statusCode } = await Service.Basket.V1.deleteCustomerOfferByBasketCustomerOfferId({
    screenName,
    ...data,
  });

  return statusCode === 200;
};

export const putCustomerOfferByBasketService = async (
  basketCustomerOfferId: string,
  {
    quantity = 1,
    requestedPrice = 0,
    requestedQuantity = 1,
    ...rest
  }: PutCustomerOfferByBasketServiceProps
) => {
  const { data } = await Service.Basket.V1.putCustomerOfferByBasketCustomerOfferId({
    screenName,
    basketCustomerOfferId,
    updateBasketCustomerOfferRequest: {
      ...rest,
      quantity,
      requestedPrice,
      requestedQuantity,
    },
  });

  return data;
};

export const getOfferByDetailProductIdService = async ({
  productId,
}: V1GetCoesOffersByDetailProductIdRequest) => {
  const { data } = await Service.COES.V1.getOffersByDetailProductId({
    productId,
    screenName,
  });

  const normalizedData = data?.offerDetail || {};

  return { data: normalizedData };
};
